import { supabase } from '../config/supabase';

export const resourcesService = {
  async getCategories() {
    const { data, error } = await supabase
      .from('hahub_categories')
      .select('*');
    if (error) throw error;
    return data;
  },

  async getAllResourcesAdmin() {
    const { data, error } = await supabase
      .from('hahub_resources')
      .select(`
        *,
        translations:hahub_resource_translations(*)
      `)
      .order('created_at', { ascending: false });
    
    if (error) throw error;
    return data;
  },

  async getResources(filters = {}) {
    let query = supabase
      .from('hahub_resources')
      .select(`
        *,
        translations:hahub_resource_translations(*)
      `)
      .eq('status', 'published');

    if (filters.category) {
      query = query.eq('category_id', filters.category);
    }

    const { data, error } = await query;
    if (error) throw error;
    return data;
  },

  async getResourceBySlug(slug) {
    const { data, error } = await supabase
      .from('hahub_resources')
      .select(`
        *,
        translations:hahub_resource_translations(*)
      `)
      .eq('slug', slug)
      .single();

    if (error) throw error;
    return data;
  },

  async createResource(resourceData) {
    const { data, error } = await supabase
      .from('hahub_resources')
      .insert([resourceData])
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async updateResource(id, resourceData) {
    const { data, error } = await supabase
      .from('hahub_resources')
      .update(resourceData)
      .eq('id', id)
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  async upsertTranslation(translationData) {
    const { data, error } = await supabase
      .from('hahub_resource_translations')
      .upsert(translationData, { onConflict: 'resource_id,language_code' })
      .select()
      .single();
    
    if (error) throw error;
    return data;
  },

  getFeaturedResources() {
    return [
      {
        id: '1',
        slug: 'chemotherapy-basics',
        title: { en: 'Chemotherapy Basics', el: 'Βασικά στοιχεία χημειοθεραπείας' },
        summary: { en: 'A practical guide to understanding your treatment.', el: 'Ένας πρακτικός οδηγός για την κατανόηση της θεραπείας σας.' },
        category: 'Treatment',
        trust_level: 'medically_reviewed'
      },
      {
        id: '2',
        slug: 'nutrition-during-treatment',
        title: { en: 'Nutrition During Treatment', el: 'Διατροφή κατά τη διάρκεια της θεραπείας' },
        summary: { en: 'Tips for maintaining strength and health.', el: 'Συμβουλές για τη διατήρηση της δύναμης και της υγείας.' },
        category: 'Support',
        trust_level: 'admin_reviewed'
      },
      {
        id: '3',
        slug: 'caregiver-self-care',
        title: { en: 'Caregiver Self-Care', el: 'Αυτοφροντίδα Φροντιστή' },
        summary: { en: 'Essential advice for those supporting others.', el: 'Απαραίτητες συμβουλές για όσους υποστηρίζουν άλλους.' },
        category: 'Caregiving',
        trust_level: 'experience_based'
      }
    ];
  }
};